import httpclient from 'libs/Axios';
import { extractGeneratedDescription } from 'features/DigitalMarketing/utils/apiResponse';

export type DmTextGenerationType = 'PROFILE' | 'RECOGNITION' | 'CONTENT';

export type DmTextGenerationPayload = {
    type: DmTextGenerationType;
    name?: string;
    role?: string;
    qualification?: string;
    experience?: string;
    gender?: string;
    title?: string;
    issued_by?: string;
    issued_year?: string;
    issued_for?: string;
    issued_level?: string;
    category_type?: string;
    time?: string;
    venue?: string;
};

const removeEmptyFields = (payload: DmTextGenerationPayload) => (
    (Object.keys(payload) as Array<keyof DmTextGenerationPayload>).reduce((nextPayload, key) => {
        const value = payload[key];

        if (value !== undefined && String(value).trim() !== '') {
            nextPayload[key] = value as any;
        }

        return nextPayload;
    }, {} as DmTextGenerationPayload)
);

export const dmTextGenerationApi = {
    async generateDescription(payload: DmTextGenerationPayload) {
        const response = await httpclient().post('/master/dm_text_generation', removeEmptyFields(payload));

        return extractGeneratedDescription(response);
    },
};
